import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface MonthlyConfirmation {
  id: string;
  user_id: string;
  year: number;
  month: number;
  confirmed_at: string;
}

/** Fetch all confirmations for a user in a given year */
export function useMonthlyConfirmations(userId: string | null, year: number) {
  return useQuery({
    queryKey: ["monthly-confirmations", userId, year],
    enabled: !!userId,
    queryFn: async (): Promise<MonthlyConfirmation[]> => {
      if (!userId) return [];
      const { data, error } = await supabase
        .from("monthly_confirmations")
        .select("*")
        .eq("user_id", userId)
        .eq("year", year)
        .order("month");
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 2 * 60 * 1000,
  });
}
